var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _polygon, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIqos22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 254.574,
    height: 634.536,
    viewBox: "0 0 254.574 634.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iqos_22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M756.277,55.622S569.959-13.244,628.8,243.054c0,0,10.7,33.875,100.736,37.887,0,0,8.469-3.12,7.578-26.3C737.11,254.643,713.04,69.487,756.277,55.622Z",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M756.277,55.622s19.612,5.126,7.577,209.718l1.089,27.793s24.318,8.758,38.581,7.866c0,0,26.3,1.337,26.3-20.058,0,0,.891-75.329-9.806-85.135",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M628.8,243.054l0.428,28.6,1.059,70.8L631.642,433l1.315,87.842,0.938,62.69c0.2,13.693,1.5,26.4,8.52,38.656A89.867,89.867,0,0,0,670.19,651.8c18.235,12.269,40.067,17.032,61.47,20.283,13.989,2.125,27.973,4.308,42.024,5.987s28.09,3.71,42.044.4c14.385-3.413,29.483-10.713,35.455-25.15a37.654,37.654,0,0,0,2.71-14.008V327.743c0,1.87-12.883,2.8-13.786,2.874-21.685,1.748-43.932-1.034-65.392-3.841-20.78-2.717-41.439-6.26-62.1-9.716-18.594-3.109-38.168-5.037-54.633-15.021-14.931-9.054-27.36-23.2-29.181-41.156",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M759.617,60.727l-3.34.912c-31.2,7.578-19.613,150.213-19.613,150.213,4.449,12.748,8.426,25.961,9.847,39.44,0.9,8.484,1.6,21.684-5.888,27.561a143.4,143.4,0,0,0-15.325,13.9",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M734.8,172.6l1.579,1.714c30.471,29.418,28.539,70.458,28.539,70.458s3.95-43.157,7.181-48.06",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M766.442,203.786c0.007-.224-9.058-24.465-31.641-41.87",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M753.679,181.426s7.4-57.932-3.807-115.826",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.497,
    cy: 150.762,
    rx: 23.958,
    ry: 8.425,
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M851.022,653.687l14.46-14.821s3.12,0.446,4.9-25.852V308.577L853.89,327.743",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M870.385,308.577l-3.789-7.514v-5.078s-4.205-14.041-36.759-21.284",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M860.7,288.3c-5.171,5.421-9.66,12.738-16.486,16.141-6.536,3.259-14.207,3.7-21.371,3.146-32.852-2.548-65.058-9.312-97.548-14.838,0,0-10.938,23.475-53.287,15.824",
    transform: "translate(-616.561 -46.458)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.951 291.822 240.036 300.514 240.036 317.898 248.951 310.097 248.951 291.822",
    fill: "#54b0ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.833,
    cy: 357.632,
    rx: 2.642,
    ry: 4.063,
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.833,
    cy: 383.789,
    rx: 1.321,
    ry: 2.031,
    fill: "#54b0ff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.833,
    cy: 407.915,
    rx: 1.321,
    ry: 2.031,
    fill: "#54b0ff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.833,
    cy: 432.041,
    rx: 1.321,
    ry: 2.031,
    fill: "#54b0ff"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.833,
    cy: 456.167,
    rx: 1.321,
    ry: 2.031,
    fill: "#54b0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqos22);
export default __webpack_public_path__ + "static/media/iqos_22.74621ac08f1bfaf8b7ec34cbd4a8cd88.svg";
export { ForwardRef as ReactComponent };